import { useIntl } from 'react-intl';
import classNames from 'classnames';

import { RecipeDifficultyIcon } from '@components/RecipeDifficultyIcon';
import { Svg } from '@components/Svg';

import { recipeMessages } from '@data/ui-messages/recipes';
import { CmsRecipeDifficulty } from '@interfaces/common';
import { minutesToISODuration } from '@utils/date';
import { intlRecipeDifficulty, intlRecipeDuration } from '@utils/intl';

import styles from './RecipeInfo.module.css';

interface RecipeInfoProps {
	serves: number;
	totalTime: number;
	difficulty: CmsRecipeDifficulty;
}

export const RecipeInfo: React.VFC<RecipeInfoProps> = ({
	serves,
	totalTime,
	difficulty,
}) => {
	const intl = useIntl();

	return (
		<div
			className={classNames(styles['recipe-info'], 'stack-inline')}
			data-testid="RecipeInfo"
		>
			<div className={classNames(styles['info-item'], 'stack-block')}>
				<h2 className="fluid-font-t6-bold">
					<Svg
						className={classNames(styles.icon, styles['serves-icon'])}
						id="serves"
					/>
					{intl.formatMessage(recipeMessages.serves)}
				</h2>
				<p className="fluid-font-t6">
					{intl.formatMessage(recipeMessages.people, { servesCount: serves })}
				</p>
			</div>

			<div className={classNames(styles['info-item'], 'stack-block')}>
				<h2 className="fluid-font-t6-bold">
					<Svg
						className={classNames(styles.icon, styles['time-icon'])}
						id="time"
					/>
					{intl.formatMessage(recipeMessages.totalTime)}
				</h2>
				<time
					className={classNames(styles['time-text'], 'fluid-font-t6')}
					dateTime={minutesToISODuration(totalTime)}
				>
					{intlRecipeDuration(intl, totalTime)}
				</time>
			</div>

			<div className={classNames(styles['info-item'], 'stack-block')}>
				<h2 className="fluid-font-t6-bold">
					<RecipeDifficultyIcon
						className={styles.icon}
						difficulty={difficulty}
					/>
					{intl.formatMessage(recipeMessages.difficulty)}
				</h2>
				<p className="fluid-font-t6">
					{intlRecipeDifficulty(intl, difficulty)}
				</p>
			</div>
		</div>
	);
};
